import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EnvironmentEnum } from '@app/core/helpers/enums/enums';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import * as Sentry from "@sentry/browser";
// import { Integrations as TracingIntegrations } from "@sentry/tracing";

if (environment.production) {
  try {
    enableProdMode();
    if (window && environment.env === EnvironmentEnum.production) {
      window.console.log = window.console.warn = window.console.info = function () { };
      console.log('version ',environment.version);
    }
    // if (environment.env !== EnvironmentEnum.dev) {
    //   Sentry.init({
    //     dsn: environment.sentry,
    //     integrations: [

    //       new Sentry.Integrations.TryCatch({
    //         XMLHttpRequest: true,
    //       }),
    //       new TracingIntegrations.BrowserTracing()

    //     ],
    //     tracesSampleRate: 1.0
    //   });
    // }
  } catch (error) { }
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
